export const translationLivechat_da_part1 = {
  livechatDefaultSupportAgent: "Supportagent",
  livechatPageTitle: "Livechat",
  livechatWorkspaceEyebrow: "Livechat-arbejdsområde",
  livechatWorkspaceTitle: "Håndter hele livechat-forløbet fra dashboardet",
  livechatWorkspaceSubtitle:
    "Arbejd med ventekøen, deltag i samtaler, svar med vedhæftninger, administrer din agentprofil og luk sessioner uden at forlade dashboardet.",
  livechatStatusWaiting: "Venter",
  livechatNotificationOsTitle: "Live chat",
  livechatNotificationOsBody: "Ny aktivitet i live chat venter på dig.",
  livechatConnectionLost:
    "Forbindelsen til live-opdateringer er afbrudt. Nye chats og notifikationer vises muligvis ikke, før forbindelsen er genoprettet.",
  livechatConnectionLostRetry: "Prøv igen",
  livechatOsNotificationsOff:
    "Browsernotifikationer er slået fra — du får ikke besked om nye chats, når denne fane ikke er i fokus.",
  livechatOsNotificationsEnable: "Slå notifikationer til",
  livechatOsNotificationsBlocked:
    "Notifikationer er blokeret af browseren. Tillad notifikationer for dette websted i browserens indstillinger for at få besked om nye chats.",
  livechatWaitingNotificationAriaSingular: "Venter, 1 ventende session",
  livechatWaitingNotificationAriaPlural: "Venter, {count} ventende sessioner",
  livechatOurTurnNotificationAriaSingular: "{label}, 1 aktiv samtale kræver dit svar",
  livechatOurTurnNotificationAriaPlural: "{label}, {count} aktive samtaler kræver dit svar",
  livechatStatusActive: "Aktiv",
  livechatStatusClosed: "Lukket",
  livechatTurnFilterAll: "Alle",
  livechatTurnFilterOurTurn: "Vores tur",
  livechatTurnFilterTheirTurn: "Deres tur",
  livechatEnvLive: "Live",
  livechatEnvTest: "Test",
  livechatBadgeLiveMode: "LIVE-TILSTAND",
  livechatBannerLiveTitle: "Live kundearbejdsområde",
  livechatBannerLiveDescription:
    "Sessioner, webhooks, agentprofil og indstillinger på denne side påvirker live trafik.",
  livechatBadgeTestMode: "TEST-TILSTAND",
  livechatBannerTestTitle: "Sandbox livechat-arbejdsområde",
  livechatBannerTestDescription:
    "Sessioner, webhooks, agentprofil og indstillinger på denne side er isoleret til testtilstand.",
  livechatIndicatorTooltipOffline: "Livechat er offline for besøgende. {reason}",
  livechatIndicatorAriaOffline: "Livechat offline for besøgende. {reason}",
  livechatIndicatorLoading: "Henter livechat-tilgængelighed…",
  livechatIndicatorNoChatbot: "Vælg en chatbot for at se tilgængelighed.",
  livechatFilterChatbotLabel: "Chatbot",
  livechatFilterAllChatbots: "Alle chatbots",
  livechatFilterMultipleChatbots: "{count} chatbots",
  livechatCannedResponsesTitle: "Canned responses",
  livechatCannedResponsesBack: "Tilbage til livechat",
  livechatCannedResponsesDescription:
    "Opret canned responses, som agenter kan indsætte i livechatten med en knap eller en slash-kommando.",
  livechatCannedResponsesAdd: "Tilføj canned response",
  livechatCannedResponsesCreateFolder: "Opret mappe",
  livechatCannedResponsesChatbotLabel: "Chatbot",
  livechatCannedResponsesFolderNameLabel: "Mappenavn",
  livechatCannedResponsesFolderNamePlaceholder: "Fx Reklamationer",
  livechatCannedResponsesFolderSave: "Gem mappe",
  livechatCannedResponsesFolderNameRequired: "Mappenavn er påkrævet.",
  livechatCannedResponsesFolderSaveFailed: "Kunne ikke gemme mappe.",
  livechatCannedResponsesFolderDeleteFailed: "Kunne ikke slette mappe.",
  livechatCannedResponsesFolderLabel: "Mappe",
  livechatCannedResponsesFolderScopeHint:
    "Mapper er per chatbot. Vælg kun {chatbotId} for at placere denne canned response i en mappe.",
  livechatCannedResponsesNoFolder: "Ingen mappe",
  livechatCannedResponsesFolderEmpty: "Træk canned responses hertil for at gemme dem i mappen.",
  livechatCannedResponsesFolderExpand: "Åbn",
  livechatCannedResponsesFolderCollapse: "Luk",
  livechatCannedResponsesDragHint: "Træk for at flytte til en mappe",
  livechatCannedResponsesMoveFailed: "Kunne ikke flytte canned response.",
  livechatCannedResponsesCommandLabel: "Command",
  livechatCannedResponsesTitleLabel: "Title",
  livechatCannedResponsesBodyLabel: "Response text",
  livechatCannedResponsesScopeLabel: "Tilgængelig på",
  livechatCannedResponsesScopeHelp:
    "Vælg hvilke chatbots denne canned response skal være tilgængelig for.",
  livechatCannedResponsesScopeAll: "Alle chatbots",
  livechatCannedResponsesEditScopeNotice: "Ændringer gælder for alle {count} valgte chatbots.",
  livechatCannedResponsesTitlePlaceholder: "Fx Complaint follow-up",
  livechatCannedResponsesBodyPlaceholder: "Skriv svaret, som skal indsættes i chatten...",
  livechatCannedResponsesSave: "Gem canned response",
  livechatCannedResponsesSaving: "Gemmer...",
  livechatCannedResponsesLoading: "Indlæser canned responses...",
  livechatCannedResponsesEmpty: "Der er endnu ingen canned responses for denne chatbot.",
  livechatCannedResponsesNoMatches: "Ingen canned responses matcher din slash-kommando.",
  livechatCannedResponsesLoadFailed: "Kunne ikke indlæse canned responses.",
  livechatCannedResponsesSaveFailed: "Kunne ikke gemme canned response.",
  livechatCannedResponsesDeleteFailed: "Kunne ikke slette canned response.",
  livechatCannedResponsesDeleteConfirmTitle: "Slet canned response?",
  livechatCannedResponsesDeleteConfirmDescription:
    "Dette sletter {command} fra {chatbotCount} {chatbotLabel}: {chatbots}.",
  livechatCannedResponsesFormRequired: "Command, title og response text er påkrævet.",
  livechatCannedResponsesInsert: "Insert",
  livechatCannedResponsesKeyboardHint: "↑↓ naviger · Enter indsæt · Esc luk",
  livechatEdit: "Rediger",
  livechatDelete: "Slet",
  livechatAgentProfileSet: "Angiv profil",
  livechatAgentProfile: "Agentprofil",
  livechatSettingsAriaLabel: "Livechat-indstillinger",
  livechatSettingsTitleAttr: "Livechat-indstillinger",
  livechatBackToConversation: "Tilbage til samtale",
  livechatVisitorSessions: "Besøgers sessioner",
  livechatNoTimestamp: "Intet tidsstempel",
  livechatAriaOpenSession: "Åbn {status} livechat-session {sessionId}",
  livechatJustNow: "Lige nu",
  livechatUnknown: "Ukendt",
  livechatSessionsEmptyFilters: "Ingen livechat-sessioner matcher de aktuelle filtre.",
  livechatLoadingMoreSessions: "Indlæser flere sessioner...",
  livechatEndOfList: "Slut på listen",
  livechatTurnOurTurn: "Vores tur",
  livechatTurnTheirTurn: "Deres tur",
  livechatVisitorLabel: "Besøgende",
  livechatCustomerTyping: "Kunden skriver",
  livechatAgentTyping: "Agent skriver",
  livechatAssignedTo: "Tildelt til",
  livechatUnassigned: "Ikke tildelt",
  livechatEnvLiveLower: "live",
  livechatEnvTestLower: "test",
  livechatSessionStatusWaiting: "venter",
  livechatSessionStatusActive: "aktiv",
  livechatSessionStatusClosed: "lukket",
  livechatActiveTurnFilterAria: "Filter for aktiv livechat-tur",
  livechatSelectChatbotBeforeSettings: "Vælg en chatbot før du ændrer livechat-indstillinger.",
  livechatFailedSaveProfile: "Kunne ikke gemme livechat-profilen.",
  livechatFailedJoinSession: "Kunne ikke deltage i livechat-sessionen.",
  livechatFailedSendReply: "Kunne ikke sende livechat-svaret.",
  livechatFailedTakeoverProviderControl: "Kunne ikke overtage livechat-sessionen.",
};
